// removed by extract-text-webpack-plugin
module.exports = {"root":"_1fOm3","closeBtn":"_1ExTe","buttonBlock":"_Mi5kb"};


//////////////////
// WEBPACK FOOTER
// ./app/components/BottomDialog/BottomDialog.scss
// module id = 1201
// module chunks = 1